var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1883_62848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.7362L0.149273 17.5499L7.20893 5.61127L7.22384 5.48487L4.11188 0.275041C3.85102 -0.161363 3.11695 -0.0510086 3.03145 0.437533L0 17.7362Z",
    fill: "#FFC24A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0878906 17.5947L0.200742 17.3985L7.1865 5.58487L4.0822 0.353856C3.82423 -0.0779727 3.16905 0.0321308 3.0844 0.515533L0.0878906 17.5947Z",
    fill: "#FFA712"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1883_62848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0878906 17.5947L0.200742 17.3985L7.1865 5.58487L4.0822 0.353856C3.82423 -0.0779727 3.16905 0.0321308 3.0844 0.515533L0.0878906 17.5947Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.49231 9.4268L11.8095 7.31184L9.4916 3.36829C9.27159 2.99499 8.65727 2.99386 8.43959 3.36829L7.20117 5.47304V5.65226L9.49223 9.4268H9.49231Z",
    fill: "#F4BD62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45099 9.33702L11.7037 7.28084L9.45099 3.4578C9.2371 3.0949 8.71742 3.05686 8.50578 3.42083L7.2609 5.55829L7.22363 5.66758L9.45099 9.33702Z",
    fill: "#FFA50E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1883_62848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45099 9.33702L11.7037 7.28084L9.45099 3.4578C9.2371 3.0949 8.71742 3.05686 8.50578 3.42083L7.2609 5.55829L7.22363 5.66758L9.45099 9.33702Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.7367L0.0676406 17.676L0.313453 17.587L9.34699 9.56585L9.46146 9.28818L7.20795 5.46094L0 17.7367Z",
    fill: "#F6820C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78195 21.7815L17.9575 17.7178L15.6229 4.90301C15.5498 4.50207 14.9979 4.34359 14.6759 4.63104L0 17.7362L8.12869 21.7812C8.38135 21.9069 8.6659 21.9729 8.95527 21.973C9.24465 21.973 9.52922 21.9071 9.78195 21.7815Z",
    fill: "#FDE068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8844 17.6832L15.5674 4.96569C15.495 4.56777 15.036 4.40314 14.7165 4.68846L0.0908203 17.7108L8.13028 21.7156C8.38101 21.8404 8.66339 21.9059 8.95056 21.906C9.23773 21.906 9.52015 21.8406 9.77095 21.716L17.8845 17.6831L17.8844 17.6832Z",
    fill: "#FCCA3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7818 21.6611C9.52909 21.7868 9.24452 21.8527 8.95516 21.8526C8.6658 21.8526 8.38127 21.7865 8.12862 21.6608L0.0653906 17.674L0 17.7356L8.12862 21.7806C8.38128 21.9063 8.66583 21.9723 8.9552 21.9724C9.24457 21.9724 9.52915 21.9065 9.78187 21.7809L17.9575 17.7172L17.9374 17.6074L9.78187 21.6612L9.7818 21.6611Z",
    fill: "#EEAB37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1883_62848",
    x: 0.0878906,
    y: 0.0839844,
    width: 7.09863,
    height: 17.5107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.619
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1883_62848"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1883_62848",
    x: 7.22363,
    y: 3.16602,
    width: 4.47998,
    height: 6.1709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.12109,
    dy: -64.0898
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.9238
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1883_62848"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1883_62848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.da0f8b9fb5b6b5374bea06bc2951e4ed.svg";
export { ForwardRef as ReactComponent };